import _objectSpread from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import { camelCase } from '../_utilities/changeCaseMirror.js';
import cx from 'classnames';
import React, { useMemo } from 'react';
export var IconFragmentElement = function IconFragmentElement(_ref) {
  var child = _ref.child,
      rest = _objectWithoutProperties(_ref, ["child"]);

  var attributes = child.attributes,
      children = child.children,
      name = child.name,
      type = child.type;

  if (type !== 'element') {
    return null;
  } // if type === 'element', it will always be that & this will never be called,
  // Moving it up to obey the rule would just waste energy
  // eslint-disable-next-line react-hooks/rules-of-hooks


  var formattedAttributes = useMemo(function () {
    return Object.assign.apply(Object, [{}].concat(_toConsumableArray(Object.entries(attributes).map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          k = _ref3[0],
          v = _ref3[1];

      return _defineProperty({}, camelCase(k), v);
    }))));
  }, [attributes]);
  var ElementName = name;
  return React.createElement(ElementName, _objectSpread(_objectSpread({}, formattedAttributes), rest), children && children.map(function (child, i) {
    return React.createElement(IconFragmentElement, {
      child: child,
      key: i
    });
  }));
};
export var IconFragment = function IconFragment(_ref5) {
  var data = _ref5.data,
      rest = _objectWithoutProperties(_ref5, ["data"]);

  var children = data.children;
  return React.createElement(React.Fragment, null, children.map(function (child, i) {
    return React.createElement(IconFragmentElement, _objectSpread({
      child: child,
      key: i
    }, rest));
  }));
};
/**
 * Icon Component
 * @param data pass an icon data object from `design-system-icons`
 *
 * Renders an Icon component from Design System Icons
 *
 * Example: `<Icon data={iconStatusSuccess}/>`
 */

export var Icon = function Icon(_ref6) {
  var align = _ref6.align,
      children = _ref6.children,
      className = _ref6.className,
      color = _ref6.color,
      data = _ref6.data,
      description = _ref6.description,
      inline = _ref6.inline,
      style = _ref6.style,
      size = _ref6.size,
      title = _ref6.title,
      viewBox = _ref6.viewBox,
      rest = _objectWithoutProperties(_ref6, ["align", "children", "className", "color", "data", "description", "inline", "style", "size", "title", "viewBox"]);

  return React.createElement("svg", _objectSpread({
    className: cx('tds-icon', {
      'tds-icon--inline': inline
    }, _defineProperty({}, "tds-".concat(data && data.id), data), {
      'tds-icon--small': data && data.id.includes('small')
    }, _defineProperty({}, "tds-icon--".concat(align), align), _defineProperty({}, "tds-icon--".concat(size), size), className),
    style: _objectSpread(_objectSpread({}, style), {}, {
      color: color
    }),
    viewBox: (data === null || data === void 0 ? void 0 : data.viewBox) || viewBox || '0 0 24 24',
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), title && React.createElement("title", null, title), description && React.createElement("desc", null, description), data && React.createElement(IconFragment, {
    data: data
  }), children && children);
};